import Vue from "vue";
import axios from "axios";

const host = window.location.host;

export default new Vue({
  data() {
    return {
      browse: {
        category: []
      },
      main: {
        hotpicks: {},
        subcategory: {},
        isLoad: false
      },
      search: {
        allSearch: {}
      },
      type: "browse"
    };
  },
  created() {
    if (host.includes("games4all")) {
      this.getBrowse();
      // this.getHotPicks();
    }
  },
  methods: {
    async getHotPicks(subcate) {
      let isload = "";
      let subCate = [];
      let allGameData = [];
      let subcateg = [];
      let allDataGame = [];

      let live = `http://cook.grabmobi.com/`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;

      //get subcategory under game
      // let subgame = await axios.get(
      //   `${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=1&domain=${host}`
      // );
      
      // subcateg = subgame.data.data;
      //get subcategory from getBrowse()
      subcate.map(item => {
        if (item.subcategory != "Arcade Games") {
          subCate.push(item);
        }
      });
     
      //get random number
      var oneHourInMs = 3600000;
      var currentTimeInMs = new Date().getTime();  // UTC time
      var timeInHour = Math.floor(currentTimeInMs / oneHourInMs);
      var numberForToday = timeInHour % 11;
      // zero-filling of numbers less than four digits might be optional for you
      // zero-filled value will be a string to maintain its leading 0s
      var DigitNumber = numberForToday.toString();
      while(DigitNumber.length < 2)
      {
        DigitNumber = 0+Number(DigitNumber);
      }
      
      for (let i = 0; i < subCate.length; i++) {
        allDataGame = await axios.get(
          `${live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${subCate[i].subcategory}&limit=50&offset=0&domain=${host}`
        );

        let divide = DigitNumber % 2;
        if(divide == 0){
          allDataGame.data.data.sort((a, b) => {
            //to sort random
            return Math.random()-0.5;
          });
        }else{
          allDataGame.data.data.sort((a, b) => {
            //to sort random
            return 0.5 - Math.random();
          });
        }

        let data_slice = allDataGame.data.data.slice(0,6)

        let subcate = subCate[i].subcategory;
        allGameData[subcate] = new Array();
        allGameData[subcate] = data_slice
      }
      isload = true;

      this.main.hotpicks = allGameData;
      (subcate.length >= 4) ? this.main.subcategory = subCate.slice(1,4) : this.main.subcategory = subCate;
      this.main.isLoad = isload;
    },
    getBrowse() {
      let live = `http://cook.grabmobi.com`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;
      //game as default
      axios.get(`${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=2&limit=10&offset=0&domain=${host}`
        )
        .then(res => {
          let data = res.data.data;

          let temp = [];
          data.map(item => {
            item.title_english = item.subcategory;
            item.route = item.title_english.toLowerCase();
            let trans = JSON.parse(item.subcategory_translate);
            let icon = JSON.parse(item.subcategory_icon);
            if (icon != null) {
              for (let [key, value] of Object.entries(icon)) {
                if (key == host) {
                  item.icon = icon[key]["class"];
                }else{
                  item.icon = icon["games4all.vip"]["class"];
                }
              }
            }
            let trans_len = Object.keys(trans).length;
            let trans_arr = Object.keys(trans);
            if (trans != null) {
              for (let i = 0; i < trans_len; i++) {
                item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
              }
            }

            temp.push(item);
          });

          let item_temp = temp.map(function(v) {
            delete v.category_translate;
            delete v.category_translate;
            delete v.category_icon;
            delete v.subcategory_translate;
            delete v.subcategory_icon;
            delete v.thumbnail_url;
            delete v.cover_img;
            return v;
          });
          this.browse.category = item_temp;
          this.getHotPicks(item_temp);
        });
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/games4all/games4all.js